import { Resource as r, API as h } from "@coveo/platform-client";
const e = class e extends r {
  /**
   * Retrieves error and warning counts for a specific resource type within an organization.
   *
   * @param {ResourceHealthEntityType} entityType The type of resource to get health metrics for (e.g., 'source', 'license', 'api-key', 'traffic')
   * @returns {Promise<ResourceHealthResponse>} The health of the specified entity type.
   */
  getResourceHealth(t) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/resource-health`, { resourceType: t })
    );
  }
};
e.baseUrl = `/rest/organizations/${h.orgPlaceholder}`;
let s = e;
export {
  s as OrganizationInternalResource
};
//# sourceMappingURL=OrganizationInternalResource.js.map
